export type Elevation = {
    low: string
    surface: string
    dropdown: string
    raised: string
}

export const elevation: Elevation = {
    low: "0 1px 3px rgba(0, 0, 0, 0.1)",
    surface: "0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06)",
    dropdown: "0 2px 8px rgba(0, 0, 0, 0.15)",
    raised: "0px 4px 8px rgba(0, 0, 0, 0.2)",
}
